// Localized route paths for each language
// Format: { englishPath: { languageCode: localizedPath } }

export const routeTranslations: Record<string, Record<string, string>> = {
  '/players': {
    en: '/players',
    es: '/jugadoras',
    pt: '/jogadoras',
    fr: '/joueurs',
    de: '/spielerinnen',
    it: '/giocatrici',
    pl: '/zawodniczki',
    cs: '/hracky',
    ru: '/igroki',
    tr: '/oyuncular',
  },
  '/players/intro': {
    en: '/players/intro',
    es: '/jugadoras/intro',
    pt: '/jogadoras/intro',
    fr: '/joueurs/intro',
    de: '/spielerinnen/intro',
    it: '/giocatrici/intro',
    pl: '/zawodniczki/intro',
    cs: '/hracky/intro',
    ru: '/igroki/intro',
    tr: '/oyuncular/intro',
  },
  '/players/services': {
    en: '/players/services',
    es: '/jugadoras/servicios',
    pt: '/jogadoras/servicos',
    fr: '/joueurs/services',
    de: '/spielerinnen/dienstleistungen',
    it: '/giocatrici/servizi',
    pl: '/zawodniczki/uslugi',
    cs: '/hracky/sluzby',
    ru: '/igroki/uslugi',
    tr: '/oyuncular/hizmetler',
  },
  '/learnmore': {
    en: '/learnmore',
    es: '/aprender-mas',
    pt: '/saiba-mais',
    fr: '/en-savoir-plus',
    de: '/erfahren-mehr',
    it: '/scopri-di-piu',
    pl: '/dowiedz-sie-wiecej',
    cs: '/zjistit-vice',
    ru: '/uznat-bolshe',
    tr: '/daha-fazla-bilgi',
  },
  '/stars': {
    en: '/stars',
    es: '/estrellas',
    pt: '/estrelas',
    fr: '/etoiles',
    de: '/sterne',
    it: '/stelle',
    pl: '/gwiazdy',
    cs: '/hvezdy',
    ru: '/zvezdy',
    tr: '/yildizlar',
  },
  '/clubs': {
    en: '/clubs',
    es: '/clubes',
    pt: '/clubes',
    fr: '/clubs',
    de: '/vereine',
    it: '/club',
    pl: '/kluby',
    cs: '/kluby',
    ru: '/kluby',
    tr: '/kulupler',
  },
  '/scouts': {
    en: '/scouts',
    es: '/ojeadores',
    pt: '/olheiros',
    fr: '/recruteurs',
    de: '/scouts',
    it: '/osservatori',
    pl: '/skauci',
    cs: '/skauti',
    ru: '/skauty',
    tr: '/skautlar',
  },
  '/coaches': {
    en: '/coaches',
    es: '/entrenadores',
    pt: '/treinadores',
    fr: '/entraineurs',
    de: '/trainer',
    it: '/allenatori',
    pl: '/trenerzy',
    cs: '/treneri',
    ru: '/trenery',
    tr: '/antrenorler',
  },
  '/agents': {
    en: '/agents',
    es: '/agentes',
    pt: '/agentes',
    fr: '/agents',
    de: '/agenten',
    it: '/agenti',
    pl: '/agenci',
    cs: '/agenti',
    ru: '/agenty',
    tr: '/menajerler',
  },
  '/about': {
    en: '/about',
    es: '/nosotros',
    pt: '/sobre',
    fr: '/a-propos',
    de: '/ueber-uns',
    it: '/chi-siamo',
    pl: '/o-nas',
    cs: '/o-nas',
    ru: '/o-nas',
    tr: '/hakkimizda',
  },
  '/news': {
    en: '/news',
    es: '/noticias',
    pt: '/noticias',
    fr: '/actualites',
    de: '/nachrichten',
    it: '/notizie',
    pl: '/aktualnosci',
    cs: '/novinky',
    ru: '/novosti',
    tr: '/haberler',
  },
  '/contact': {
    en: '/contact',
    es: '/contacto',
    pt: '/contato',
    fr: '/contact',
    de: '/kontakt',
    it: '/contatti',
    pl: '/kontakt',
    cs: '/kontakt',
    ru: '/kontakty',
    tr: '/iletisim',
  },
  '/performance': {
    en: '/performance',
    es: '/rendimiento',
    pt: '/desempenho',
    fr: '/performance',
    de: '/leistung',
    it: '/prestazioni',
    pl: '/wydajnosc',
    cs: '/vykon',
    ru: '/rezultaty',
    tr: '/performans',
  },
  '/between-the-lines': {
    en: '/between-the-lines',
    es: '/entre-lineas',
    pt: '/entre-linhas',
    fr: '/entre-les-lignes',
    de: '/zwischen-den-zeilen',
    it: '/tra-le-righe',
    pl: '/miedzy-wierszami',
    cs: '/mezi-radky',
    ru: '/mezhdu-strok',
    tr: '/satirlar-arasi',
  },
  '/media': {
    en: '/media',
    es: '/medios',
    pt: '/midia',
    fr: '/medias',
    de: '/medien',
    it: '/media',
    pl: '/media',
    cs: '/media',
    ru: '/media',
    tr: '/medya',
  },
  '/business': {
    en: '/business',
    es: '/negocios',
    pt: '/negocios',
    fr: '/entreprise',
    de: '/geschaeft',
    it: '/affari',
    pl: '/biznes',
    cs: '/obchod',
    ru: '/biznes',
    tr: '/is',
  },
  '/daily-fuel': {
    en: '/daily-fuel',
    es: '/combustible-diario',
    pt: '/combustivel-diario',
    fr: '/carburant-quotidien',
    de: '/taeglicher-treibstoff',
    it: '/carburante-quotidiano',
    pl: '/codzienne-paliwo',
    cs: '/denni-palivo',
    ru: '/ezhednevnoe-toplivo',
    tr: '/gunluk-yakit',
  },
  '/login': {
    en: '/login',
    es: '/acceso',
    pt: '/entrar',
    fr: '/connexion',
    de: '/anmelden',
    it: '/accedi',
    pl: '/logowanie',
    cs: '/prihlaseni',
    ru: '/vhod',
    tr: '/giris',
  },
  '/portal': {
    en: '/portal',
    es: '/portal',
    pt: '/portal',
    fr: '/portail',
    de: '/portal',
    it: '/portale',
    pl: '/portal',
    cs: '/portal',
    ru: '/portal',
    tr: '/portal',
  },
  '/services': {
    en: '/services',
    es: '/servicios',
    pt: '/servicos',
    fr: '/services',
    de: '/dienstleistungen',
    it: '/servizi',
    pl: '/uslugi',
    cs: '/sluzby',
    ru: '/uslugi',
    tr: '/hizmetler',
  },
  '/mentorship': {
    en: '/mentorship',
    es: '/mentoria',
    pt: '/mentoria',
    fr: '/mentorat',
    de: '/mentoring',
    it: '/mentoring',
    pl: '/mentoring',
    cs: '/mentoring',
    ru: '/mentorstvo',
    tr: '/mentorluk',
  },
  '/consultation': {
    en: '/consultation',
    es: '/consulta',
    pt: '/consulta',
    fr: '/consultation',
    de: '/beratung',
    it: '/consulenza',
    pl: '/konsultacja',
    cs: '/konzultace',
    ru: '/konsultatsiya',
    tr: '/danismanlik',
  },
  '/pro-performance': {
    en: '/pro-performance',
    es: '/rendimiento-pro',
    pt: '/desempenho-pro',
    fr: '/performance-pro',
    de: '/profi-leistung',
    it: '/prestazioni-pro',
    pl: '/wydajnosc-pro',
    cs: '/profi-vykon',
    ru: '/pro-rezultaty',
    tr: '/pro-performans',
  },
  '/elite-performance': {
    en: '/elite-performance',
    es: '/rendimiento-elite',
    pt: '/desempenho-elite',
    fr: '/performance-elite',
    de: '/elite-leistung',
    it: '/prestazioni-elite',
    pl: '/wydajnosc-elite',
    cs: '/elitni-vykon',
    ru: '/elite-rezultaty',
    tr: '/elit-performans',
  },
  '/tactical': {
    en: '/tactical',
    es: '/tactico',
    pt: '/tatico',
    fr: '/tactique',
    de: '/taktisch',
    it: '/tattico',
    pl: '/taktyka',
    cs: '/taktika',
    ru: '/taktika',
    tr: '/taktik',
  },
  '/action-reports': {
    en: '/action-reports',
    es: '/informes-de-accion',
    pt: '/relatorios-de-acao',
    fr: '/rapports-action',
    de: '/aktionsberichte',
    it: '/rapporti-azione',
    pl: '/raporty-akcji',
    cs: '/akcni-zpravy',
    ru: '/otchety-deystviy',
    tr: '/aksiyon-raporlari',
  },
  '/technical': {
    en: '/technical',
    es: '/tecnico',
    pt: '/tecnico',
    fr: '/technique',
    de: '/technisch',
    it: '/tecnico',
    pl: '/technika',
    cs: '/technika',
    ru: '/tehnika',
    tr: '/teknik',
  },
  '/mental': {
    en: '/mental',
    es: '/mental',
    pt: '/mental',
    fr: '/mental',
    de: '/mental',
    it: '/mentale',
    pl: '/mentalny',
    cs: '/mentalni',
    ru: '/mentalnoe',
    tr: '/zihinsel',
  },
  '/strength-power-speed': {
    en: '/strength-power-speed',
    es: '/fuerza-potencia-velocidad',
    pt: '/forca-potencia-velocidade',
    fr: '/force-puissance-vitesse',
    de: '/kraft-power-geschwindigkeit',
    it: '/forza-potenza-velocita',
    pl: '/sila-moc-szybkosc',
    cs: '/sila-vykon-rychlost',
    ru: '/sila-moshch-skorost',
    tr: '/guc-hiz',
  },
  '/conditioning': {
    en: '/conditioning',
    es: '/acondicionamiento',
    pt: '/condicionamento',
    fr: '/conditionnement',
    de: '/konditionierung',
    it: '/condizionamento',
    pl: '/kondycja',
    cs: '/kondice',
    ru: '/konditsiya',
    tr: '/kondisyon',
  },
  '/nutrition': {
    en: '/nutrition',
    es: '/nutricion',
    pt: '/nutricao',
    fr: '/nutrition',
    de: '/ernaehrung',
    it: '/nutrizione',
    pl: '/odzywianie',
    cs: '/vyziva',
    ru: '/pitanie',
    tr: '/beslenme',
  },
  '/analysis': {
    en: '/analysis',
    es: '/analisis',
    pt: '/analise',
    fr: '/analyse',
    de: '/analyse',
    it: '/analisi',
    pl: '/analiza',
    cs: '/analyza',
    ru: '/analiz',
    tr: '/analiz',
  },
};

// Create reverse mapping: localized path -> english path
export const reverseRouteMap: Record<string, string> = {};
Object.entries(routeTranslations).forEach(([englishPath, translations]) => {
  Object.values(translations).forEach((localizedPath) => {
    reverseRouteMap[localizedPath] = englishPath;
  });
});

// Get localized path for a given english path and language
export function getLocalizedPath(englishPath: string, language: string): string {
  // First try exact match for the full path
  if (routeTranslations[englishPath] && routeTranslations[englishPath][language]) {
    return routeTranslations[englishPath][language];
  }
  
  // Handle dynamic routes like /players/:id
  const basePath = englishPath.split('/').slice(0, 2).join('/');
  const rest = englishPath.split('/').slice(2).join('/');
  
  const translations = routeTranslations[basePath];
  if (translations && translations[language]) {
    return rest ? `${translations[language]}/${rest}` : translations[language];
  }
  
  return englishPath;
}

// Get english path from any localized path
export function getEnglishPath(localizedPath: string): string {
  // Handle dynamic routes
  const basePath = '/' + localizedPath.split('/').filter(Boolean)[0];
  const rest = localizedPath.split('/').slice(2).join('/');
  
  const englishPath = reverseRouteMap[basePath];
  if (englishPath) {
    return rest ? `${englishPath}/${rest}` : englishPath;
  }
  
  return localizedPath;
}

// Get all possible paths for a route (for router config)
export function getAllPathVariants(englishPath: string): string[] {
  const translations = routeTranslations[englishPath];
  if (!translations) return [englishPath];
  
  return [...new Set(Object.values(translations))];
}
